module.exports = __webpack_public_path__ + "img/Icon_Crear_PEI_Hover.bba3aef2.svg";